import { createPortal } from "react-dom";

import styled from "styled-components";

import { useTabularContext } from "./contexts/tabular-context.js";

const Backdrop = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.28);
    z-index: 2400;
`;

const Dialog = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: min(560px, calc(100vw - 32px));
    max-height: calc(100vh - 48px);
    overflow: auto;
    border-radius: 12px;
    border: 1px solid #d7e0ea;
    background: #fff;
    box-shadow: 0 20px 40px rgba(15, 23, 42, 0.18);
    z-index: 2401;
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 18px;
    border-bottom: 1px solid #e7edf4;
    font-size: 16px;
    font-weight: 700;
    color: #23384d;
`;

const Body = styled.div`
    padding: 18px;
    color: #42576b;
    font-size: 14px;
    line-height: 1.65;

    p {
        margin: 0 0 14px;
    }

    strong {
        color: #23384d;
    }
`;

const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 0 18px 18px;
`;

const Button = styled.button`
    height: 36px;
    padding: 0 14px;
    border-radius: 8px;
    border: 1px solid #cfd9e5;
    background: #fff;
    color: #42576b;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
`;

export function TableGeneratorHelpModal() {
    const { helpShown, hideHelp } = useTabularContext();

    if (!helpShown) {
        return null;
    }

    return createPortal(
        <>
            <Backdrop onClick={hideHelp} />
            <Dialog className="table-generator-help-modal" role="dialog" aria-modal="true">
                <Header>
                    <span>Help</span>
                    <Button type="button" onClick={hideHelp}>
                        Close
                    </Button>
                </Header>
                <Body>
                    <p>This tool inserts and edits LaTeX tables directly in visual mode.</p>
                    <p>
                        <strong>How it works.</strong> Select cells, rows, or columns to update borders, alignment,
                        merge state, and structure without writing the full LaTeX manually.
                    </p>
                    <p>
                        <strong>Customizing tables.</strong> If you need more advanced layouts, you can still switch to
                        code mode and edit the underlying `tabular` environment directly.
                    </p>
                    <p>
                        <strong>Captions and labels.</strong> Caption actions work when the `tabular` environment is a
                        direct child of the surrounding `table` environment.
                    </p>
                </Body>
                <Footer>
                    <Button type="button" onClick={hideHelp}>
                        Close
                    </Button>
                </Footer>
            </Dialog>
        </>,
        document.body,
    );
}
